export const UNCHIN_SETTEI_OPTIONS: App.OptionsFnc = (t) => [
  { label: t('customer_setting.rebate_fare'), value: '01' },
  { label: t('customer_setting.total_fare'), value: '02' },
];
